import React from 'react';
import { FormFeedback, FormGroup, Label, Input } from 'reactstrap';
import Switch from 'react-toggle-switch';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import { get } from 'lodash';

const jsToMomentDateMap = {
  'm/d/Y': 'MM/DD/YYYY',
};

export const renderHelpText = (text) => {
  if (!text) { return null; }
  return <small className="form-text text-muted">{text}</small>;
};

export const handleDateChange = (field, form, dateString) => {
  const { name } = field;

  const date = moment(dateString).toISOString();
  form.setFieldValue(name, date);
  form.setFieldTouched(name, true);
};

export const renderField = ({ field, form, type, label, helpText, step, dateFormat, required, ...props }) => {
  const { children } = props;
  const { name, value } = field;
  const { errors, touched } = form;
  const isInvalid = !!get(errors, name) && get(touched, name);
  let input;

  switch (type) {
    case 'number':
      input = (
        <Input
          {...field}
          type={type}
          step={(step || 1)}
          invalid={isInvalid}
        />
      );
      break;

    case 'select':
      input = (
        <Input
          {...field}
          type={type}
        >
          {children}
        </Input>
      );
      break;

    case 'date':
      input = (
        <Flatpickr
          className="form-control"
          options={{
            onChange: array => handleDateChange(field, form, array[0]),
            defaultDate: (value ? moment(value).format(jsToMomentDateMap[dateFormat]) : null),
            dateFormat,
          }}
        />
      );
      break;

    case 'switch':
      input = (
        <div>
          <Switch
            on={value}
            onClick={() => {
              form.setFieldValue(name, !value);
              form.setFieldTouched(name, true);
            }}
          />
        </div>
      );
      break;

    default: {
      input = <Input {...field} type={type} {...props} invalid={isInvalid} />;
    }
  }

  return (
    <FormGroup>
      {label && <Label for={label} className={required ? 'required' : ''}>{label}</Label>}
      {input}
      {get(touched, name) && get(errors, name) && <FormFeedback>{get(errors, name)}</FormFeedback>}
      {renderHelpText(helpText)}
    </FormGroup>
  );
};



// WEBPACK FOOTER //
// ./src/core/utils/formik.js